export default (elmApp) => {
    // Local Storage Handling..
    if (elmApp.ports.manageLocalStorage) {
        elmApp.ports.manageLocalStorage.subscribe(data => {
            if (!data) {
                console.log("No data set for Local Storage to Handle.");
            } else {

                switch (data.action) {
                    case "clear":
                        localStorage.clear();
                        break;
                    case "update":
                        localStorage.setItem(data.key, data.value);
                        break;
                    case "remove":
                        localStorage.removeItem(data.key);
                        break;
                    default:
                        if (elmApp.ports.backFromLocalStorage)
                            elmApp.ports.backFromLocalStorage.send(localStorage.getItem(data.key) || "")
                        break;
                }
            }
        });
    }

    // Scroll item to bottom..
    if (elmApp.ports.scrollToBottom) {
        elmApp.ports.scrollToBottom.subscribe(itemID => {
            let itemToScroll = document.getElementById(itemID);
            itemToScroll.scrollTop = itemToScroll.scrollHeight;
        });
    }

    // Scroll item Grandpa to bottom..
    if (elmApp.ports.scrollGrandToBottom) {
        elmApp.ports.scrollGrandToBottom.subscribe(itemID => {
            let item = document.getElementById(itemID);
            // Search Parent to sidebar parent...
            let dept = 3;
            while (item && item != undefined && dept != 0) {
                if (item.getAttribute('class').includes("sidebar-dashlet-content")) {
                    dept = 0;
                } else {
                    item = item.parentNode;
                    dept -= 1;
                }
            }

            // Set Scroll Down to Bottom...
            if (item && item != undefined) {
                item.scrollTop = item.scrollHeight;
            }
        });
    }

    // Proceed to Logout the App...
    if (elmApp.ports.doLogout) {
        elmApp.ports.doLogout.subscribe(data => {
            // Expiring cookies...
            let hostNme = window.location.hostname;
            let appDomain = /\d+\.\d+\.\d+\.\d+/.test(hostNme) ? hostNme : /.+\..+\..+/.test(hostNme) ? hostNme.match(/(?:[\s.].+)/)[0] : hostNme;
            ["ticket", "username"].forEach((key_, idx) => {
                document.cookie = key_ + "=;expires=" + (new Date()).toUTCString() + ";path=/;domain=" + appDomain;
            });

            // Redirect to Login...
            window.location.href = process.env.ELM_APP_LOGIN_URL + window.location.origin + data.path
        });
    }

    // Listen to CHI-e Information SSE Channel...
    if (elmApp.ports.callUpInformationSSE) {
        elmApp.ports.callUpInformationSSE.subscribe(data => {
            let evtSource = new EventSource(data.path, { headers: { "Content-type": "text/event-stream" } });

            evtSource.onopen = evt => {
                console.log("SSE Channel Connection Opened...");
            }

            evtSource.onerror = evt => {
                console.log("There was an error listening on the SSE Channel...");
                console.log(evt);
                if ((evtSource.readyState == EventSource.CLOSED) && elmApp.ports.sseInformationState) {
                    elmApp.ports.sseInformationState.send({ closed_onerror: true });
                }
            };

            evtSource.onmessage = evt => {
                console.log("Successfully listening Channel...");
                let evtDta = JSON.parse(evt.data);

                // Send notice back to app model...
                if (elmApp.ports.sseInformationState) {
                    console.log("Sending Data back to ELM model...");
                    elmApp.ports.sseInformationState.send(evtDta);
                }
            };
        });
    }
}